import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/ZipCodeDef';

const autoGenerateSuccess = (zipcode: string) => {
  const data = {
    city: 'BELO HORIZONTE',
    country: 'Brazil',
    state: 'MG',
    streetName: 'ABRE CAMPO',
    zipCode: zipcode,
  };
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      body: {},
      params: {
        zipcode,
      },
    },
    configResponse: {
      status: 200,
      data: data,
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const autoGenerateResponse = autoGenerateSuccess(MocksDef.ZIP_CODE);

const generatedSuccessMocks = [autoGenerateResponse];

const autoGenerate = (zipcode: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          body: {},
          params: {
            zipcode: `${zipcode.slice(0, -1)}${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseZipcode = autoGenerate(MocksDef.ZIP_CODE);
  return [...responseZipcode];
};

const errorsGenerated = autoGenerateErrorsMock();

const GetZipCodeMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default GetZipCodeMocks;
